var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 41,
    viewBox: "0 0 217 41",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0886 4.55556H31.1786L30.065 13.6667H11.8851L11.6124 15.9444H29.7923L27.2699 36.4444H18.1799L17.6118 41H8.52183L9.08996 36.4444H0L1.11352 27.3333H19.2934L19.5661 25.0556H1.38622L3.90868 4.55556H12.9986L13.544 0H22.634L22.0886 4.55556Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7458 27.3333H57.9258L56.8122 36.4444H29.5424L33.451 4.55556H60.7209L59.6074 13.6667H41.4275L41.1548 15.9444H59.3347L58.1984 25.0556H40.0185L39.7458 27.3333Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2633 4.55556L89.1497 13.6667H70.9698L69.2882 27.3333H87.4681L86.3546 36.4444H59.0847L62.9934 4.55556H90.2633Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5358 4.55556H101.626L98.8306 27.3333H107.921L110.716 4.55556H119.806L115.897 36.4444H88.6271L92.5358 4.55556Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.348 4.55556L146.826 25.0556H141.69L146.848 36.4444H136.349L131.191 25.0556H128.646L127.259 36.4444H118.169L122.078 4.55556H149.348ZM139.145 13.6667H130.055L129.782 15.9444H138.872L139.145 13.6667Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.915 27.3333H176.095L174.982 36.4444H147.712L151.62 4.55556H178.89L177.777 13.6667H159.597L159.324 15.9444H177.504L176.368 25.0556H158.188L157.915 27.3333Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.777 15.9444H188.867L187.458 27.3333H196.548L198.229 13.6667H180.049L181.163 4.55556H208.433L204.524 36.4444H177.254L179.777 15.9444Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.886 36.4444H206.797L207.91 27.3333H217L215.886 36.4444Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d1e6c078.svg";
export { ForwardRef as ReactComponent };